import React from "react";
import LegalPage from "pages/LegalPage.js";

export default ({ headingText = "Terms and Conditions" }) => (
  <LegalPage source="terms-and-conditions.json" headingText={headingText} />
);
